import type { Reducer } from '@reduxjs/toolkit';

import { resourceUpserters } from '../core';
import * as entitlementsActions from './entitlementsActions';
import { type EntitlementProps, type EntitlementsStore, mkEntitlementsStore } from './entitlementsTypes';

const entitlementsReducer: Reducer<EntitlementsStore> = (state = mkEntitlementsStore(), action) => {
  if (entitlementsActions.getEntitlements.match(action) || entitlementsActions.createEntitlement.match(action)) {
    return state.set('isLoading', true);
  }
  if (
    entitlementsActions.getEntitlementsSuccess.match(action) ||
    entitlementsActions.createEntitlementSuccess.match(action)
  ) {
    const { payload } = action;
    // POST success carries a bare array limited to the service's allowlist; merge so omitted records survive.
    return resourceUpserters.upsertResources(state, Array.isArray(payload) ? { resources: payload } : payload);
  }
  if (
    entitlementsActions.getEntitlementsFailure.match(action) ||
    entitlementsActions.createEntitlementFailure.match(action)
  ) {
    return resourceUpserters.completeWithError<EntitlementProps>(state, action.payload);
  }
  return state;
};

export default entitlementsReducer;
